import React, { useState, useEffect } from "react";
import { cn } from "../../utils/utils";
import { log } from "util";
import useTime from "../../hooks/useTime";
import { useSelector } from "react-redux";
import ImageIcon from "./ImageIcon";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import { useViewport } from "../../hooks/useViewport";
type Props = {
  name: string;
  title?: string;
  placeHolder?: string;
  handleChangeEvent: (value: string, name: string) => void;
  value?: string | null;
  isDisabled?: boolean;
  customClass?: string;
  customLabelClass?: string;
  min?: string;
  max?: string;
  isRequired?: boolean;
  inputType?: string;
  dateInputProps?: any;
};

function DateInput2({
  name,
  title,
  min,
  max,
  customClass,
  customLabelClass,
  placeHolder = "",
  handleChangeEvent,
  inputType = "date",
  value = null,
  isRequired = true,
  isDisabled = false,
  dateInputProps,
}: Props) {
  const lang = useSelector((state: any) => state?.user?.lang);
  const [rawDate,setRawDate] = useState('')
  const [minValue,setMinValue] = useState('')
  const [isNewField,setIsNewField] = useState(false)
  const formatDate = (date: Date) => {
    if (isNaN(date.getTime())) return "";
    let options = { day: "numeric", month: "short", year: "numeric" };

    if (inputType === "datetime-local") {
      options = {
        ...options,
        //@ts-ignore
        hour: "numeric",
        minute: "numeric",
      };
    }
    //|"2-digit",
    //@ts-ignore
    return date.toLocaleDateString("en-GB", options).replace(",", ""); // e.g., "1 Jan 2025"
  };
  const formatInputValue = (val: string | null) => {
    if (!val) return "";

    if (inputType === "week") return val;

    const date = new Date(val);
    if (isNaN(date.getTime())) return "";

    if (inputType === "month") {
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
    }

    if (inputType === "datetime-local") {
      return date.toISOString().slice(0, 16);
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [date, setDate] = useState<string | null>(
    value ? formatDate(new Date(value)) : null
  );

  const displayData = (date: string) => {
    if (inputType === "week") {
      return date;
    }
    const enterdDate = new Date(date);
    let options = { day: "numeric", month: "short", year: "numeric" };
    if (inputType === "month") {
      //@ts-ignore
      delete options.day;
    }
    if (inputType === "datetime-local") {
      options = {
        ...options,
        //@ts-ignore
        hour: "numeric",
        minute: "numeric",
      };
    }

    return enterdDate
      .toLocaleDateString(
        lang == "ar" ? "ar-EG-u-nu-latn" : "en-GB",
        //@ts-ignore
        options
      )
      .replace(",", ""); // e.g., "1 Jan 2025"
  };
  
  const dateRef = React.useRef<HTMLInputElement>(null);
  const { getDateinLang } = useTime();
  // Keep `date` state in sync with the `value` prop
  useEffect(() => {
    if (dateInputProps.value) {
      if (inputType === "week") {
        setDate(dateInputProps.value);
        return;
      }
      if(min && new Date(dateInputProps.value).getTime() > new Date(min).getTime() ){
         setIsNewField(true) 
         setMinValue(min)
      }else{
        setMinValue('')
      }
      setDate(formatDate(new Date(dateInputProps.value)));
      return;
    }
    if (value) {
      if (inputType === "week") {
        setDate(value);
        return;
      }
      if(min && new Date(value).getTime() > new Date(min).getTime() ){
         setIsNewField(true) 
         setMinValue(min)
      }
      setDate(formatDate(new Date(value)));
    } else {
      setIsNewField(true)
       setMinValue(min || '')
      setDate(null);
    }
  }, [value, dateInputProps.value]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('test from change');
    
    if(e.target.value === ''){
    e.target.value = rawDate
      
    }
    const rawValue = e.target.value;
    setRawDate(e.target.value)

    if (inputType === "week") {
      setDate(rawValue);
      handleChangeEvent(rawValue, name);
      return;
    }

    let formattedValue = "";
    if (rawValue) {
      const dateObj = new Date(rawValue);
      if (!isNaN(dateObj.getTime())) {
        formattedValue = formatDate(dateObj);
      }
    }

    setDate(formattedValue);
    handleChangeEvent(formattedValue.replace("Sept", "Sep"), name);
  };
  const handleInput = ()=>{
    console.log('from input event');
    
  }
  const { isAppleDevice, mobileOS } = useViewport();
  return (
    <div
      className={cn(
        "col-span-1 flex flex-col h-fit gap-2 relative",
        customClass
      )}
    >
      {title && (
        <p className="flex text-sm  text-primary dark:text-white dark:bg-primary">
          {title} {isRequired && <pre className="text-red-500">*</pre>}
        </p>
      )}
      <label
        className={cn(
          "p-3  h-full w-full border border-gray-300 dark:bg-primaryLight outline-none rounded-md relative text-sm ",
          customLabelClass,
          isDisabled && "cursor-not-allowed bg-[#f3f3f3] dark:bg-primaryLight"
        )}
        htmlFor={name}
        onClick={() => {
          console.log(dateRef);

          if (dateRef.current && !isDisabled) {
            if (typeof dateRef.current.showPicker === "function") {
              console.log(dateRef.current);

              dateRef.current.showPicker();
            } else {
              dateRef.current.focus();
            }
          }
        }}
      >
        <p
          className={cn(
            date ? "text-primary dark:text-white" : "text-secondary"
          )}
        >
          {date ? displayData(date) : placeHolder}
        </p>
        {/* <img loading="lazy"
          className={`absolute ${
            lang == "ar" ? "left-1" : "right-1"
          }  top-2 w-7`}
          src={calenderIcon}
          alt=""
        /> */}
        <ImageIcon
          Icon={CalendarIcon}
          className={`absolute ${
            lang == "ar" ? "left-1" : "right-1"
          }  top-2 w-7`}
        />
      </label>
      <input
        onInput={handleInput}
        {...dateInputProps}
        ref={dateRef}
        type={inputType}
        readOnly={isDisabled}
        disabled={isDisabled}
        min={minValue}
        max={max || ""}
        className={`w-0 h-0 absolute no-clear top-0 ${isAppleDevice && "opacity-0"}`}
        name={name}
        id={name}
        value={formatInputValue(value || dateInputProps.value)}
        onChange={handleChange}
      />
    </div>
  );
}
export default DateInput2;
